module.exports = __webpack_public_path__ + "img/huiliu.40dc0a2a.png";